import { render, staticRenderFns } from "./groupInfo.vue?vue&type=template&id=215c83da&scoped=true&"
import script from "./groupInfo.vue?vue&type=script&lang=js&"
export * from "./groupInfo.vue?vue&type=script&lang=js&"
import style0 from "./groupInfo.vue?vue&type=style&index=0&id=215c83da&prod&lang=less&"
import style1 from "./groupInfo.vue?vue&type=style&index=1&id=215c83da&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215c83da",
  null
  
)

export default component.exports